<template>
  <div>
    <div>
      <div class="white-background list-top-margin">
        <!-- 面包屑导航 -->
        <div class="page-top">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>生产管理</el-breadcrumb-item>
            <el-breadcrumb-item>
              <span style="color:#000;font-weight:bold;">任务</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!-- tab页 -->
        <div>
          <el-row class="page-row">
            <el-col :span="12">
              <el-tabs v-model="tabName" @tab-click="tabClick">
                <el-tab-pane
                  :label="item.label"
                  :name="item.name"
                  v-for="item in tabList"
                  :key="item.name"
                ></el-tab-pane>
              </el-tabs>
            </el-col>
            <!-- <el-col :span="12" style="text-align:right; padding:5px 5px;">
                <el-button type="primary" size="small" icon="el-icon-check" plain @click="saveCurrent">保存当前</el-button>
                <el-button type="primary" size="small" icon="el-icon-s-operation" @click="filterScheme">筛选方案</el-button>
            </el-col> -->
          </el-row>
        </div>

        <!-- 搜索筛选 -->
        <el-form :model="form" class="user-search" label-width="110px" size="small">
          <el-row>
            <el-col :span="7">
              <el-form-item label="工单编号">
                <el-input size="small" v-model="form.orderCode" placeholder="请输入工单编号" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="工序编号">
                <el-input size="small" v-model="form.processCode" placeholder="请输入工序编号" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="工序名称">
                <el-select
                v-model="form.processName"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in processNameList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3" class="text-align-right">
              <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-col>
          </el-row>
          <el-row v-show="!isFold" class="search-row">
            <el-col :span="7">
              <el-form-item label="工序状态">
                <el-select
                v-model="form.taskStatus"
                  clearable
                  multiple
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in taskStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="计划数">
                <div style="display:flex;">
                  <el-input-number
                    class="input-number"
                    v-model="form.planSatrtNum"
                    controls-position="right"
                    :min="0"
                    placeholder="最小数"
                  ></el-input-number>
                  <span style="width:12px;text-align:center;">-</span>
                  <el-input-number
                    class="input-number"
                    v-model="form.planEndNum"
                    controls-position="right"
                    :min="0"

                    placeholder="最大数"
                  ></el-input-number>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7" style="clear:both;">
              <el-form-item label="良品数">
                <div style="display:flex;">
                  <el-input-number
                    class="input-number"
                    v-model="form.goodSatrtNum"
                    controls-position="right"
                    :min="0"

                    placeholder="最小数"
                  ></el-input-number>
                  <span style="width:12px;text-align:center;">-</span>
                  <el-input-number
                    class="input-number"
                    v-model="form.goodEndNum"
                    controls-position="right"
                    :min="0"

                    placeholder="最大数"
                  ></el-input-number>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="不良品数">
                <div style="display:flex;">
                  <el-input-number
                    class="input-number"
                    v-model="form.nogoodSatrtNum"
                    controls-position="right"
                    :min="0"

                    placeholder="最小数"
                  ></el-input-number>
                  <span style="width:12px;text-align:center;">-</span>
                  <el-input-number
                    class="input-number"
                    v-model="form.nogoodEndNum"
                    controls-position="right"
                    :min="0"

                    placeholder="最大数"
                  ></el-input-number>
                </div>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="计划开始时间">
                <el-select
                  v-model="form.createCondition"
                  placeholder="请选择"
                  style="width: 120px;"
                  @change="createConditionChange('planStartTime')"
                >
                  <el-option
                    v-for="item in conditionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-if="form.createCondition == 'between'"
                  key="0"
                  class="half-width"
                  v-model="form.planStartTime"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00','23:59:59']"
                ></el-date-picker>
                <el-date-picker
                  v-if="form.createCondition !== 'between' && form.createCondition !== 'auto'"
                  class="half-width"
                  v-model="form.planStartTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择日期"
                  default-time="00:00:00"
                ></el-date-picker>
                <el-select
                  v-model="form.planStartTime"
                  placeholder="请选择"
                  v-if="form.createCondition == 'auto'"
                  class="half-width"
                  :class="{'w120':form.dynamicCreateValue == '7'}"
                  @change="dynamicCreateValueChange"
                >
                  <el-option
                    v-for="item in dynamicDate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="form.planStartTime"
                  placeholder="请选择"
                  v-if="form.createCondition == 'auto' && form.dynamicCreateValue == '7'"
                  style="margin-top: 8px;width: 120px;"
                >
                  <el-option
                    v-for="item in dateOneOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-tooltip content="只支持1-365的正整数">
                  <el-input-number
                    v-if="form.createCondition == 'auto' && form.dynamicCreateValue == '7'"
                    @blur="dateInputCreateBlur"
                    v-model="form.planStartTime"
                    step-strictly
                    controls-position="right"
                    :min="0"
                    :max="365"
                    style="margin-left: 8px;margin-top: 8px;width: 120px;"
                  ></el-input-number>
                </el-tooltip>
                <el-select
                  v-model="form.planStartTime"
                  placeholder="请选择"
                  v-if="form.createCondition == 'auto' && form.dynamicCreateValue == '7'"
                  style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);"
                >
                  <el-option
                    v-for="item in dateTwoOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="计划结束时间">
                <el-select
                  v-model="form.updateCondition"
                  placeholder="请选择"
                  style="width: 120px;"
                  @change="updateConditionChange('planEndTime')"
                >
                  <el-option
                    v-for="item in conditionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-if="form.updateCondition == 'between'"
                  key="0"
                  class="half-width"
                  v-model="form.planEndTime"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00','23:59:59']"
                ></el-date-picker>
                <el-date-picker
                  v-if="form.updateCondition !== 'between' && form.updateCondition !== 'auto'"
                  key="1"
                  class="half-width"
                  v-model="form.planEndTime"
                  type="datetime"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                <el-select
                  v-model="form.planEndTime"
                  placeholder="请选择"
                  v-if="form.updateCondition == 'auto'"
                  class="half-width"
                  :class="{'w120':form.dynamicUpdateValue == '7'}"
                  @change="dynamicUpdateValueChange"
                >
                  <el-option
                    v-for="item in dynamicDate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="form.planEndTime"
                  placeholder="请选择"
                  v-if="form.updateCondition == 'auto' && form.dynamicUpdateValue == '7'"
                  style="margin-top: 8px;width: 120px;"
                >
                  <el-option
                    v-for="item in dateOneOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-tooltip content="只支持1-365的正整数">
                  <el-input-number
                    v-if="form.updateCondition == 'auto' && form.dynamicUpdateValue == '7'"
                    @blur="dateInputUpdateBlur"
                    v-model="form.planEndTime"
                    step-strictly
                    controls-position="right"
                    :min="0"
                    :max="365"
                    style="margin-left: 8px;margin-top: 8px;width: 120px;"
                  ></el-input-number>
                </el-tooltip>
                <el-select
                  v-model="form.planEndTime"
                  placeholder="请选择"
                  v-if="form.updateCondition == 'auto'&& form.dynamicUpdateValue == '7'"
                  style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);"
                >
                  <el-option
                    v-for="item in dateTwoOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="实际开始时间">
                <el-select
                  v-model="form.actualCondition"
                  placeholder="请选择"
                  style="width: 120px;"
                  @change="createConditionChange('actualStartTime')"
                >
                  <el-option
                    v-for="item in conditionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-if="form.actualCondition == 'between'"
                  key="0"
                  class="half-width"
                  v-model="form.actualStartTime"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00','23:59:59']"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
                <el-date-picker
                  v-if="form.actualCondition !== 'between' && form.actualCondition !== 'auto'"
                  class="half-width"
                  v-model="form.actualStartTime"
                  type="datetime"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                <el-select
                  v-model="form.actualStartTime"
                  placeholder="请选择"
                  v-if="form.actualCondition == 'auto'"
                  class="half-width"
                  :class="{'w120':form.dynamicActualValue == '7'}"
                  @change="dynamicCreateValueChange"
                >
                  <el-option
                    v-for="item in dynamicDate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="form.actualStartTime"
                  placeholder="请选择"
                  v-if="form.actualCondition == 'auto' && form.dynamicActualValue == '7'"
                  style="margin-top: 8px;width: 120px;"
                >
                  <el-option
                    v-for="item in dateOneOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-tooltip content="只支持1-365的正整数">
                  <el-input-number
                    v-if="form.actualCondition == 'auto' && form.dynamicActualValue == '7'"
                    @blur="dateInputCreateBlur"
                    v-model="form.actualStartTime"
                    step-strictly
                    controls-position="right"
                    :min="0"
                    :max="365"
                    style="margin-left: 8px;margin-top: 8px;width: 120px;"
                  ></el-input-number>
                </el-tooltip>
                <el-select
                  v-model="form.actualStartTime"
                  placeholder="请选择"
                  v-if="form.actualCondition == 'auto' && form.dynamicActualValue == '7'"
                  style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);"
                >
                  <el-option
                    v-for="item in dateTwoOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="实际结束时间">
                <el-select
                  v-model="form.actualCondition1"
                  placeholder="请选择"
                  style="width: 120px;"
                  @change="updateConditionChange('actualEndTime')"
                >
                  <el-option
                    v-for="item in conditionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-if="form.actualCondition1 == 'between'"
                  key="0"
                  class="half-width"
                  v-model="form.actualEndTime"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00','23:59:59']"
                ></el-date-picker>
                <el-date-picker
                  v-if="form.actualCondition1 !== 'between' && form.actualCondition1 !== 'auto'"
                  key="1"
                  class="half-width"
                  v-model="form.actualEndTime"
                  type="datetime"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                <el-select
                  v-model="form.actualEndTime"
                  placeholder="请选择"
                  v-if="form.actualCondition1 == 'auto'"
                  class="half-width"
                  :class="{'w120':form.dynamicActualValue1 == '7'}"
                  @change="dynamicUpdateValueChange"
                >
                  <el-option
                    v-for="item in dynamicDate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="form.actualEndTime"
                  placeholder="请选择"
                  v-if="form.actualCondition1 == 'auto' && form.dynamicActualValue1 == '7'"
                  style="margin-top: 8px;width: 120px;"
                >
                  <el-option
                    v-for="item in dateOneOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-tooltip content="只支持1-365的正整数">
                  <el-input-number
                    v-if="form.actualCondition1 == 'auto' && form.dynamicActualValue1 == '7'"
                    @blur="dateInputUpdateBlur"
                    v-model="form.actualEndTime"
                    step-strictly
                    controls-position="right"
                    :min="0"
                    :max="365"
                    style="margin-left: 8px;margin-top: 8px;width: 120px;"
                  ></el-input-number>
                </el-tooltip>
                <el-select
                  v-model="form.actualEndTime"
                  placeholder="请选择"
                  v-if="form.actualCondition1 == 'auto'&& form.dynamicActualValue1 == '7'"
                  style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);"
                >
                  <el-option
                    v-for="item in dateTwoOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>


            <el-col :span="7">
              <el-form-item label="产品编号">
                <el-input size="small" v-model="form.productCode" placeholder="请输入产品编号" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="产品名称">
                <el-input size="small" v-model="form.productName" placeholder="请输入产品名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="产品规格">
                <el-input size="small" v-model="form.specs" placeholder="请输入产品规格" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="报工权限">
                <el-select
                  v-model="form.userIdList"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in workAuthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="创建人">
                <el-select
                 v-model="form.creater"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in workAuthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="更新人">
                <el-select
                 v-model="form.updater"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in workAuthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="创建时间">
                <el-select
                  v-model="form.createCondition1"
                  placeholder="请选择"
                  style="width: 120px;"
                  @change="createConditionChange('createTime')"
                >
                  <el-option
                    v-for="item in conditionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-if="form.createCondition1 == 'between'"
                  key="0"
                  class="half-width"
                  v-model="form.createTime"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00','23:59:59']"
                ></el-date-picker>
                <el-date-picker
                  v-if="form.createCondition1 !== 'between' && form.createCondition1 !== 'auto'"
                  class="half-width"
                  v-model="form.createTime"
                  type="datetime"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                <el-select
                  v-model="form.createTime"
                  placeholder="请选择"
                  v-if="form.createCondition1 == 'auto'"
                  class="half-width"
                  :class="{'w120':form.dynamicCreateValue == '7'}"
                  @change="dynamicCreateValueChange"
                >
                  <el-option
                    v-for="item in dynamicDate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="form.createTime"
                  placeholder="请选择"
                  v-if="form.createCondition1 == 'auto' && form.dynamicCreateValue == '7'"
                  style="margin-top: 8px;width: 120px;"
                >
                  <el-option
                    v-for="item in dateOneOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-tooltip content="只支持1-365的正整数">
                  <el-input-number
                    v-if="form.createCondition1 == 'auto' && form.dynamicCreateValue == '7'"
                    @blur="dateInputCreateBlur"
                    v-model="form.createTime"
                    step-strictly
                    controls-position="right"
                    :min="1"
                    :max="365"
                    style="margin-left: 8px;margin-top: 8px;width: 120px;"
                  ></el-input-number>
                </el-tooltip>
                <el-select
                  v-model="form.createTime"
                  placeholder="请选择"
                  v-if="form.createCondition1 == 'auto' && form.dynamicCreateValue == '7'"
                  style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);"
                >
                  <el-option
                    v-for="item in dateTwoOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider>
            <i :class="!isFold?'el-icon-caret-top':'el-icon-caret-bottom'" @click="fold"></i>
          </el-divider>
        </el-form>
      </div>
      <div class="white-background">
        <el-row class="tbl-btn">
          <el-col :span="12" class="tbl-btn-left">
            <el-dropdown class="left-default-margin right-default-margin" @command="handleCommand" trigger="click">
              <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-button type="text" icon="el-icon-circle-plus-outline" @click="addTemplate">新增打印模板</el-button>
            <el-button type="text" icon="el-icon-edit-outline" @click="saveTemplate">编辑打印模板</el-button> -->
            <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportDataNew">导出</el-button>
          </el-col>
          <!-- <el-col :span="12" class="tbl-btn-right">
            <el-button type="primary" size="small" icon="el-icon-setting">移动端卡片配置</el-button>
            <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
          </el-col> -->
        </el-row>
        <!--列表-->
        <el-table
          size="small"
          ref="tableData"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          :header-cell-style="_headerStyle"
          stripe
          border
          element-loading-text="加载中"
          style="width: 100%;"
          row-key="_id"
          @selection-change="handleTblSelectionChange"
        >
          <el-table-column align="left" type="selection" :reserve-selection="true" width="60"></el-table-column>
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column sortable label="工单编号" width="170">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.orderCode" placement="top">
                <span class="txt-overflow">{{scope.row.orderCode}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="产品编号">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.productCode" placement="top">
                <span class="txt-overflow">{{scope.row.productCode}}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="产品名称">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.productName" placement="top">
                <span class="txt-overflow">{{scope.row.productName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="specs" label="产品规格"></el-table-column>
          <el-table-column   label="工序编号" >
            <template slot-scope="scope">
              <span>{{scope.row.processCode}}</span>
              <el-tag v-for="(item,index) in scope.row.status" :type="changeStatusColor(item)" :key="item" style="height:28px;margin-left: 4px;" :style="{'marginBottom':(index!=scope.row.status.length-1)?'8px':'0'}">{{item}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="processName" label="工序名称" width="80"></el-table-column>
          <el-table-column prop="userNameList" label="报工权限" width="140">
            <template slot-scope="scope">
              <span v-if="scope.row.userIdList ">{{scope.row.userIdList | transfer(workAuthList)}}</span>


            </template>
          </el-table-column>
          <el-table-column prop="allocateList" label="分配列表" width="140" >
            <template slot-scope="scope">
              <span v-if="scope.row.allocateList">{{scope.row.allocateList | transfer(workAuthList)}}</span>

            </template>
          </el-table-column>

          <el-table-column prop="coefficient" label="报工数配比" width="100"></el-table-column>
          <el-table-column sortable prop="planNum" label="计划数" width="120"></el-table-column>
          <el-table-column sortable prop="goodNum" label="良品数" width="120"></el-table-column>
          <el-table-column prop="nongoodNum" label="不良品数" width="80"></el-table-column>
          <el-table-column prop="taskStatus" label="任务状态" width="80"></el-table-column>
          <!-- <el-table-column prop="deptNo" label="优先级" width="80"></el-table-column> -->
          <el-table-column prop="planStartTime" label="计划开始时间" width="150"></el-table-column>
          <el-table-column prop="planEndTime" label="计划结束时间" width="150"></el-table-column>
          <el-table-column prop="actualStartTime" label="实际开始时间" width="150"></el-table-column>
          <el-table-column prop="actualEndTime" label="实际结束时间" width="150"></el-table-column>
          <!-- <el-table-column prop="deptNo" label="子工艺路线" width="100"></el-table-column> -->
          <el-table-column prop="creater" label="创建人" width="140"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
          <!-- <el-table-column prop="updateTime" label="更新时间" width="140"></el-table-column> -->
          <el-table-column v-for="item in setList" :key="item._id" :prop="item.fieldName" :label="item.fieldName">
            <template slot-scope="scope">
              <span>{{scope.row['taskProcess'][item.fieldName]?scope.row['taskProcess'][item.fieldName]:''}}</span>

            </template>
          </el-table-column>


          <el-table-column align="left" label="操作" min-width="190" fixed="right">
            <template slot-scope="scope">
              <el-tooltip content="查看">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-view"
                  circle
                  @click="handleView(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="编辑">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                  @click="handleEdit(scope.$index, scope.row)"
                  :disabled="scope.row.order.orderStatus != '执行中'"
                ></el-button>
              </el-tooltip>
              <!-- <el-tooltip content="打印">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-printer"
                  circle
                  @click="handlePrint(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip> -->
              <el-tooltip content="删除">
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="handleDelete(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
    </div>

    <SaveScheme :diaVisible="schemeVisible"></SaveScheme>
    <FilterScheme :diaVisible="filterSchemeVisible"  :listData="tabList" @filterRefresh="filterRefresh"></FilterScheme>
    <el-dialog
     title="编辑任务"
     :visible.sync="dialogVisible"
     width="900px"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="done"
    >
    <create-layout v-if="dialogVisible" :userData="userData" :modelStatus="modelStatus"  :editRow="editRow" :setList="setList" :userList="workAuthList" @done="done"></create-layout>
    </el-dialog>

    <el-dialog
     title="打印"
     :visible.sync="printVisible"
     width="900px"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="done"
    >
    <print-layout v-if="printVisible" :userData="userData"  :editRow="editRow"  :type="'task'" :userList="workAuthList" @done="done"></print-layout>
    </el-dialog>

    <el-dialog
     :title="templateTitle"
     :visible.sync="printTemplateVisible"
     width="900px"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="done"
    >
    <print-template v-if="printTemplateVisible" :userData="userData"  :editRow="editRow" :type="'task'"  :userList="workAuthList" @done="done"></print-template>
    </el-dialog>
  </div>
</template>
<script>
import { taskGetList,taskDelete ,taskBatchDelete,processGetAll} from '@/api/basicData';
import { queryAllUserList,queryAllCustomSet,savePrintTemplate} from '@/api/business';
import Pagination from "../../components/Pagination";
import SaveScheme from "../../components/SaveScheme";
import FilterScheme from "../../components/FilterScheme";
import CreateLayout from "./CreateLayout";
import PrintLayout from "@/views/task/PrintLayout";
import PrintTemplate from "@/views/task/PrintTemplate";
import {exportDataToExcel,transfer} from '@/utils/util';

export default {
  name: "Task",
  components: {
    Pagination,
    SaveScheme,
    FilterScheme,
    CreateLayout,
    PrintLayout,
    PrintTemplate
  },
  data() {
    return {
      setList:[],
      filterSchemeVisible:false,
      schemeVisible:false,
      isBatchPrint: false,
      form: {
        factoryId: "",
      },
      listData: [],
      loading: false,
      isFold: true,
      tblSelectionList: [],
      processNameList: [],
      orderStatusList: [
        {
          label: "未开始",
          value: "未开始"
        },
        {
          label: "执行中",
          value: "执行中"
        },
        {
          label: "已结束",
          value: "已结束"
        },
        {
          label: "已取消",
          value: "已取消"
        }
      ],
      workAuthList: [],
      taskStatusList: [
        {
          label: "未开始",
          value: "未开始"
        },
        {
          label: "执行中",
          value: "执行中"
        },
        {
          label: "已结束",
          value: "已结束"
        },
        {
          label: "已取消",
          value: "已取消"
        }
      ],
      priorityList: [
        {
          label: "加急",
          value: "0"
        },
        {
          label: "无",
          value: "1"
        }
      ],
      distributeStatusList: [
        {
          label: "已分配",
          value: "0"
        },
        {
          label: "未分配",
          value: "1"
        }
      ],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      tabList: [
        {
          label: "车间看板",
          icon:'el-icon-tickets',
          color:'#000',
          name: "0"

        },
      ],
      tabName: "0",
      conditionOptions: [
        {
          value: "between",
          label: "选择范围"
        },
        {
          value: "lt",
          label: "小于"
        },
        {
          value: "lte",
          label: "小于等于"
        },
        {
          value: "eq",
          label: "等于"
        },
        {
          value: "gt",
          label: "大于"
        },
        {
          value: "gte",
          label: "大于等于"
        }
      ],
      dynamicDate: [
        {
          value: "0",
          label: "今天"
        },
        {
          value: "1",
          label: "昨天"
        },
        {
          value: "2",
          label: "本周"
        },
        {
          value: "3",
          label: "上周"
        },
        {
          value: "4",
          label: "本月"
        },
        {
          value: "5",
          label: "上月"
        },
        {
          value: "6",
          label: "近三月"
        },
        {
          value: "7",
          label: "自定义"
        }
      ],
      dateOneOptions: [
        {
          value: "过去",
          label: "过去"
        },
        {
          value: "未来",
          label: "未来"
        }
      ],
      dateTwoOptions: [
        {
          value: "日",
          label: "日"
        },
        {
          value: "周",
          label: "周"
        },
        {
          value: "月",
          label: "月"
        },
        {
          value: "季度",
          label: "季度"
        },
        {
          value: "年",
          label: "年"
        }
      ],
      dialogVisible:false,
      userData:{},
      editRow:{},
      modelStatus:'',
      params:{
        condition: {
        },
        currentPage: 1,
        pageSize: 10,
      },
      printVisible:false,
      printTemplateVisible:false,
      templateTitle:'新增打印模板'
    };
  },
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData);
      this.form.factoryId = this.userData.factoryId;
      this.init();
      this.getdata();
    }
  },
  methods: {
    //导出数据前对数据处理，变为想要的格式。
    filterTableData(data) {
      data.forEach((item) => {
        item.userNameList = transfer(item.userIdList,this.workAuthList);
        item.allocateList = transfer(item.allocateList,this.workAuthList);
      });
      return data;
    },
    exportDataNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        this.exportData();
        return;
      }
      const header = [
        "工单编号",
        '产品编号',
        '产品名称',
        '产品规格',
        '工序编号',
        '工序名称',
        '报工权限',
        '分配列表',
        '报工数配比',
        '计划数',
        '良品数',
        '不良品数',
        '任务状态',
        '计划开始时间',
        '计划结束时间',
        '实际开始时间',
        '实际结束时间',
        '创建人',
        '创建时间',
        '更新时间',

      ];
      const filterVal = [
        'orderCode',
        'productCode',
        'productName',
        'specs',
        'processCode',
        'processName',
        'userNameList',
        'allocateList',
        'coefficient',
        'planNum',
        'goodNum',
        'nongoodNum',
        'taskStatus',
        'planStartTime',
        'planEndTime',
        'actualStartTime',
        'actualEndTime',
        'creater',
        'createTime',
        'updateTime',

      ];
      for(let k = 0;k<this.setList.length;k++){
        header.push(this.setList[k]['fieldName']);
        filterVal.push(this.setList[k]['fieldName']);
      }
      let filterData =this.filterTableData(JSON.parse(JSON.stringify(this.tblSelectionList)));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"任务清册"+ Date.now());
    },
    exportData(){
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
        },
        tableName:'任务',
        collection:'task',
      }

      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/api/exportExcel';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "任务清册.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(params));

      },
    addTemplate(){
      this.templateTitle = "新增打印模板"
      this.editRow = null;
      this.printTemplateVisible = true;
    },
    saveTemplate(){
      this.templateTitle = "编辑打印模板"
      this.editRow = this.listData[0];
      this.printTemplateVisible = true;


    },
    handlePrint(index,row){
      this.editRow = row;
      this.printVisible = true;
    },
    blurDistruct(index,row){
      this.$set(this.listData[index],'isFlag',false);
    },
    uptDistruct(index,row){

      this.$set(this.listData[index],'isFlag',true);
    },
    async init(){

      let res = await processGetAll(this.userData.factoryId);
      if(res['code'] == 200){
        this.processNameList = res.data.map(function(item){
          return {
            label:item.processName,
            value:item.processCode
          }
        });
      }
      res = await queryAllUserList(this.userData.factoryId);
      if(res['code'] == 200){
        this.workAuthList = res.data.map(function(item){
          return {
            label:item.name + '(' + item.account + ')',
            value:item._id,
          }
        });
      }
      res = await queryAllCustomSet(this.userData.factoryId,'process');
      this.setList = [];
      if(res['code'] == 200){
        this.setList = res['data'];
      }
    },
    search(){
      this.params['currentPage'] = 1;
      this.params['pageSize'] = 10;
      this.getdata();
    },
    getdata() {
      this.loading = true
      this.params['condition'] = {};
      for(var key in this.form){

        if(this.form[key] && this.form[key] != null && (this.form[key].length > 0 || this.form[key].toString() != '')){
          if(key == "planSatrtNum" || key == "planEndNum"){
            this.params.condition['planNum'] = {
              begin:this.form.planSatrtNum,
              end:this.form.planEndNum,
              type:'between',
              data:'num'
            }
          }else if(key == "goodSatrtNum" || key == "goodEndNum"){
            this.params.condition['goodNum'] = {
              begin:this.form.goodSatrtNum,
              end:this.form.goodEndNum,
              type:'between',
              data:'num'
            }
          }else if(key == "nogoodSatrtNum" || key == "nogoodEndNum"){
            this.params.condition['nongoodNum'] = {
              begin:this.form.nogoodSatrtNum,
              end:this.form.nogoodEndNum,
              type:'between',
              data:'num'
            }
          }else if(key == "planStartTime" || key == "planEndTime"
          || key == "createTime" || key == "updateTime" || key == "actualStartTime"
          || key  == "actualEndTime"){
            if(key == "planStartTime"){
               if(this.form.createCondition == "between" && this.form.planStartTime.length == 2){
                  this.params['condition'][key] = {
                      begin:this.form.planStartTime[0],
                      end:this.form.planStartTime[1],
                      type:this.form.createCondition ,
                      data:'time'
                    }
                }else{
                  this.params['condition'][key] = {
                    type:this.form.createCondition,
                    value:this.form.planStartTime,
                    data:'time'
                  }
                }
            }else if(key == "planEndTime"){
               if(this.form.updateCondition == "between" && this.form.planEndTime.length == 2){
                  this.params['condition'][key] = {
                      begin:this.form.planEndTime[0],
                      end:this.form.planEndTime[1],
                      type:this.form.updateCondition,
                      data:'time'
                    }
                }else{
                  this.params['condition'][key] = {
                    type:this.form.updateCondition,
                    value:this.form.planEndTime,
                    data:'time'
                  }
                }
            }else if(key == "createTime"){
               if(this.form.createCondition1 == "between" && this.form.createTime.length == 2){
                  this.params['condition'][key] = {
                      begin:this.form.createTime[0],
                      end:this.form.createTime[1],
                      type:this.form.createCondition1,
                      data:'time'
                    }
                }else{
                  this.params['condition'][key] = {
                    type:this.form.createCondition1,
                    value:this.form.createTime,
                    data:'time'
                  }
                }
            }else if(key == "updateTime"){
               if(this.form.updateCondition1 == "between" && this.form.updateTime.length == 2){
                  this.params['condition'][key] = {
                      begin:this.form.updateTime[0],
                      end:this.form.updateTime[1],
                      type:this.form.updateCondition1,
                      data:'time'
                    }
                }else{
                  this.params['condition'][key] = {
                    type:this.form.updateCondition1,
                    value:this.form.updateTime,
                    data:'time'
                  }
                }
            }else if(key == "actualEndTime"){
              if(this.form.actualCondition1 == "between" && this.form.actualEndTime.length == 2){
                  this.params['condition'][key] = {
                      begin:this.form.actualEndTime[0],
                      end:this.form.actualEndTime[1],
                      type:this.form.actualCondition1,
                      data:'time'
                    }
                }else{
                  this.params['condition'][key] = {
                    type:this.form.actualCondition1,
                    value:this.form.actualEndTime,
                    data:'time'
                  }
                }
            }else if(key == "actualStartTime"){
              if(this.form.actualCondition == "between" && this.form.actualStartTime.length == 2){
                  this.params['condition'][key] = {
                      begin:this.form.actualStartTime[0],
                      end:this.form.actualStartTime[1],
                      type:this.form.actualCondition,
                      data:'time'
                    }
                }else{
                  this.params['condition'][key] = {
                    type:this.form.actualCondition,
                    value:this.form.actualStartTime,
                    data:'time'
                  }
                }
            }
          }else if(key != "updateCondition1" && key != "createCondition1"
          && key != "updateCondition" && key != "createCondition"
          && key != "actualCondition" && key != "actualCondition1"){

            this.params['condition'][key] = this.form[key];
          }
        }
      }
      taskGetList(this.params).then(res => {
        if(res.code == 200){
          this.pageparm = res.data;
          this.listData = res.data.list;
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    handleDelete(index,row){
      this.$confirm('确认删除任务？操作将同时删除关联的报工，删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          // const pageLoading = this.openLoading(); //调用方法，打开loading遮罩层
          taskDelete(row._id).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
              // pageLoading.close();
          }).catch(err => {
            // pageLoading.close();
            this.$message.error('删除失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 批量操作
    handleCommand(options){
      var selection = this.$refs.tableData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            idList:idList
          }
          taskBatchDelete(idList).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
      if(this.tblSelectionList.length > 0){
        this.isBatchPrint = true;
      }else{
        this.isBatchPrint = false;
      }
    },
    // 分页插件事件
    callFather(param) {
      this.params['currentPage'] = param['currentPage'];
      this.params['pageSize'] = param['pageSize'];

      this.getdata();
    },
    fold() {
      this.isFold = !this.isFold;
    },
    createConditionChange: function(val) {

      this.$set(this.form, "dynamicCreateValue", "");
      this.$set(this.form, val, "");
    },
    updateConditionChange: function(val) {
      this.$set(this.form, "dynamicUpdateValue", "");
      this.$set(this.form, val, "");

    },
    dynamicUpdateValueChange:function(){
      if(this.form.dynamicUpdateValue == '7'){
        this.$set(this.form,'dateUpdateInput','1')
      }else{
        delete this.form.dateUpdateInput
      }
    },
    tabClick(tab, event) {
    },
    saveCurrent(){
        this.schemeVisible = true;
    },
    filterScheme(){
        this.filterSchemeVisible = true;
    },
    filterRefresh(val){
      this.tabList = val;
    },
    dynamicCreateValueChange:function(){
      if(this.form.dynamicCreateValue == '7'){
        this.$set(this.form,'dateCreateInput','1')
      }else{
        delete this.form.dateCreateInput
      }
    },
    dateInputCreateBlur:function(){
      if(this.form.dateCreateInput == undefined){
        this.$set(this.form,'dateCreateInput','1')
      }
    },
    handleEdit: function(index, row) {
      this.modelStatus = 'edit'
      this.editRow = row
      this.dialogVisible = true
    },
    handleView(index, row){
      this.modelStatus = 'view'
      this.editRow = row
      this.dialogVisible = true
    },
    done(data){
      if (data&&data.type === "save"){
        this.search();
      }
      this.dialogVisible = false;
      this.printVisible = false;
      this.printTemplateVisible = false;
    },
    changeStatusColor(options){
      if(options == '延期'){
        return 'danger'
      }else if(options == '执行中'){
        return 'success'
      }{
        return ''
      }
    },
  }
};
</script>
<style>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number{
    width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/task/Task.vue